import {
  ComponentConfig,
  ComponentType,
  LayoutTypes,
} from "../services/types/ComponentTypes";

export const screen_2208_attendance_sessions: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Attendance",
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          padding: 0,
          margin: 0,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "check_in_time",
            apiname: "attendance_sessions",
            Name: "attendance_sessions",
            TableName: "attendance_sessions",
            View: "view_attendance_sessions",
            HasLockedColumn: false,
            DisplayName: "Attendance Session Log",
            fields: [
              {
                IncludeLabel: true,
                Label: "Check In",
                BindValue: "dt_check_in",
                Json_Attribute: "check_in_time",
                ControlType: "DateTime",
                valueFormat: "time",
                showInSummary: true,
              },
              {
                IncludeLabel: true,
                Label: "Check Out",
                BindValue: "dt_check_out",
                Json_Attribute: "check_out_time",
                ControlType: "DateTime",
                valueFormat: "time",
                showInSummary: true,
              },
              {
                IncludeLabel: true,
                Label: "Hours",
                BindValue: "txt_hours",
                Json_Attribute: "session_hours",
                ControlType: "TextView",
                valueFormat: "duration",
                showInSummary: true,
              },
            ],
          },
        ],
      },
    ],
  },
];
